var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnderline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.25C6.41421 2.25 6.75 2.58579 6.75 3V10C6.75 11.3924 7.30312 12.7277 8.28769 13.7123C9.27226 14.6969 10.6076 15.25 12 15.25C13.3924 15.25 14.7277 14.6969 15.7123 13.7123C16.6969 12.7277 17.25 11.3924 17.25 10V3C17.25 2.58579 17.5858 2.25 18 2.25C18.4142 2.25 18.75 2.58579 18.75 3V10C18.75 11.7902 18.0388 13.5071 16.773 14.773C15.5071 16.0388 13.7902 16.75 12 16.75C10.2098 16.75 8.4929 16.0388 7.22703 14.773C5.96116 13.5071 5.25 11.7902 5.25 10V3C5.25 2.58579 5.58579 2.25 6 2.25ZM3.25 21C3.25 20.5858 3.58579 20.25 4 20.25H20C20.4142 20.25 20.75 20.5858 20.75 21C20.75 21.4142 20.4142 21.75 20 21.75H4C3.58579 21.75 3.25 21.4142 3.25 21Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnderline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/underline.60063ea80b399b5d184428dc036d59b1.svg";